<template>
    <div class="free-table">
        <el-table ref="elTable" :data="data" :header-cell-class-name="tableHeaderClassName" :row-style="tableRowClassStyle" v-bind="$attrs" v-on="$listeners">
            <template v-for="item in tbColumns">
                <template v-if="!item.hidden">
                    <el-table-column
                        v-if="item.slotScope"
                        v-bind="item"
                        :key="item.prop"
                        v-on="$listeners"
						:show-overflow-tooltip="true"
						min-width="180">
                        <template slot-scope="scope">
                            <slot :name="item.prop" v-bind="scope"></slot>
                        </template>
                    </el-table-column>

                    <free-column v-else v-bind="$attrs" :key="item.prop" :column="item" />
                </template>
            </template>
			<el-empty slot="empty" description="暂无数据"></el-empty>
        </el-table>
        <template v-if="pagination" class="pagination">
            <pagination v-bind="$attrs" v-on="$listeners" />
        </template>
    </div>
</template>

<script>
import { tableMixin } from "utils/mixins";
import FreeColumn from './columu';
import Pagination from '../Pagination';

export default {
    name: 'FreeTable',
    mixins: [tableMixin],
    components: {
        Pagination,
        FreeColumn
    },
    props: {
        data: Array,
        column: Array,
        columnsProps: Object,
        pagination: {
            type: Boolean,
            default: false
        },
        clearSelection: Boolean
    },
    watch: {
        clearSelection() {
            this.$refs.elTable.clearSelection();
        }
    },
    computed: {
        tbColumns() {
            const { column, columnsProps: props } = this;

            return column.map(col => {
                const it = Object.assign({}, props, col);
                return it;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.free-table {
    .pagination-container {
        text-align: center;
        
    }
}
</style>
